// @flow
import styled from 'styled-components';

export const LoadingIndicatorContainer = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    padding: 1rem;
    text-align: center;
    height: 100%;
`;

export const LoadingIndicatorContent = styled.div`
    flex: 1;
    max-width: 10rem;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/indicators/loading/styles.js